import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import TooltipIcons from "../../../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import { Edit} from "feather-icons-react/build/IconComponents";

// Mock Data
const mockSalaries = [
  {
    id: 1,
    name: "John Doe",
    bNumber: "B001",
    salary: 85000,
    department: "HR",
    status: "Active",
  },
  {
    id: 2,
    name: "Jane Smith",
    bNumber: "B002",
    salary: 95000,
    department: "IT",
    status: "Active",
  },
  {
    id: 3,
    name: "Michael Brown",
    bNumber: "B003",
    salary: 72000,
    department: "Finance",
    status: "Inactive",
  },
  {
    id: 4,
    name: "Emily Davis",
    bNumber: "B004",
    salary: 68000,
    department: "Marketing",
    status: "Active",
  },
  {
    id: 5,
    name: "David Wilson",
    bNumber: "B005",
    salary: 88000,
    department: "IT",
    status: "Active",
  },
  {
    id: 6,
    name: "Sarah Lee",
    bNumber: "B006",
    salary: 65000,
    department: "Sales",
    status: "On Leave",
  },
  {
    id: 7,
    name: "Robert Taylor",
    bNumber: "B007",
    salary: 90000,
    department: "Operations",
    status: "Active",
  },
  {
    id: 8,
    name: "Lisa Anderson",
    bNumber: "B008",
    salary: 60000,
    department: "HR",
    status: "Active",
  },
];

const Salaries = () => {
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formSalary, setFormSalary] = useState("");

  // Filter options
  const departments = [...new Set(mockSalaries.map((e) => e.department))];
  const statuses = ["All", "Active", "Inactive", "On Leave"];

  // Filtered data
  const filteredData = useMemo(() => {
    return mockSalaries.filter((emp) => {
      const matchesDept = !selectedDept || emp.department === selectedDept;
      const matchesStatus =
        !selectedStatus ||
        selectedStatus === "All" ||
        emp.status === selectedStatus;

      return matchesDept && matchesStatus;
    });
  }, [selectedDept, selectedStatus]);

  // Open Offcanvas
  const openEdit = (row) => {
    setEditData(row);
    setFormSalary(row.salary);
    setOffcanvasOpen(true);
  };

  // Close Offcanvas
  const closeOffcanvas = () => {
    setOffcanvasOpen(false);
    setEditData(null);
    setFormSalary("");
  };

  // Save
  const saveEdit = () => {
    console.log("Updated salary:", formSalary, "for", editData.name);
    closeOffcanvas();
  };

  // Columns
  const columns = [
    {
      title: (
        <div className="form-check form-check-md">
          <input className="form-check-input" type="checkbox" />
        </div>
      ),
      key: "checkbox",
      render: () => (
        <div className="form-check form-check-md">
          <input className="form-check-input" type="checkbox" />
        </div>
      ),
      width: 50,
    },
    {
      title: "Employee Name",
      key: "name",
      render: (row) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-sm me-2 bg-primary text-white rounded-circle">
            {row.name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </div>
          <span className="fw-medium">{row.name}</span>
        </div>
      ),
    },
    {
      title: "Bio ID",
      dataIndex: "bNumber",
      render: (text) => (
        <span className="badge bg-light text-dark">{text}</span>
      ),
    },
    {
      title: "Salary",
      dataIndex: "salary",
      render: (salary) => <strong>{salary.toLocaleString("en-US")}</strong>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (row) => (
        <div className="text-center">
          <Link className="btn btn-sm " name="Edit" onClick={() => openEdit(row)}>
            <Edit className="info-img text-info" />
          </Link>
        </div>
      ),
      width: 100,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header */}
        <div className="page-header">
          <div className="add-item d-flex">

             <div className="page-title">
                            <nav aria-label="breadcrumb">
                              <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                  <Link to="/rollcall/dashboard">
                                    <i className="fas fa-home fa-lg" />
                                  </Link>
                                </li>
                                <h4 className="breadcrumb-item " aria-current="page">
                                Salaries
                                </h4>
                              </ol>
                            </nav>
                            <h6>Manage employee salary details</h6>
                          </div>
            {/* <div className="page-title">
              <h4>Salaries</h4>
              <h6>Manage employee salary details</h6>
            </div> */}
          </div>
          <ul className="table-top-head">
            <TooltipIcons />
            <RefreshIcon />
            <CollapesIcon />
            {/* <li>
              <a href="#" className="btn btn-primary">
                <Download className="me-2" size={16} /> Export
              </a>
            </li> */}
            <li>
              <Link to="#" className="btn btn-success">
             <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </li>
          </ul>
        </div>

        {/* Card */}
        <div className="card table-list-card">
          <div className="">
            {/* Filters */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              {/* Search removed */}
              <div className="search-set"></div>

              {/* Filters */}
              <div className="d-flex align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <div className="input-blocks">
                    <i data-feather="grid" className="info-img" />
                    <select
                      className="select"
                      value={selectedDept}
                      onChange={(e) => setSelectedDept(e.target.value)}
                    >
                      <option value="">All Departments</option>
                      {departments.map((dept) => (
                        <option key={dept} value={dept}>
                          {dept}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="dropdown me-2">
                  <div className="input-blocks">
                    <i data-feather="check-circle" className="info-img" />
                    <select
                      className="select"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      {statuses.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <Table
                dataSource={filteredData}
                columns={columns}
                rowKey="id"
                pagination={{ pageSize: 10 }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Offcanvas Drawer */}
      <div
        className={`offcanvas offcanvas-end ${offcanvasOpen ? "show" : ""}`}
        style={{
          visibility: offcanvasOpen ? "visible" : "hidden",
          width: offcanvasOpen ? "400px" : "0",
        }}
        tabIndex="-1"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title">Edit Salary - {editData?.name}</h5>
          <button
            type="button"
            className="btn-close text-reset"
            onClick={closeOffcanvas}
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          {editData && (
            <>
              <div className="mb-3">
                <label className="form-label">B-Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={editData.bNumber}
                  readOnly
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Salary ($)</label>
                <input
                  type="number"
                  className="form-control"
                  value={formSalary}
                  onChange={(e) => setFormSalary(parseInt(e.target.value) || 0)}
                  min="0"
                  step="1000"
                  placeholder="Enter salary"
                />
              </div>
            </>
          )}
        </div>
        <div className="offcanvas-footer border-top p-3 d-flex gap-2">
          <button
            type="button"
            className="btn btn-secondary flex-fill"
            onClick={closeOffcanvas}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary flex-fill"
            onClick={saveEdit}
          >
            Save Changes
          </button>
        </div>
      </div>

      {/* Backdrop */}
      {offcanvasOpen && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={closeOffcanvas}
          style={{ zIndex: 1040 }}
        />
      )}

      {/* Footer */}
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2014-2025 © Pereco. All Right Reserved</p>
        <p>
          Designed & Developed By{" "}
          <Link to="#" className="text-primary">
            Pereco
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Salaries;
